import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import {
  ADMIN_NAVIGATION,
  ADMIN_SECTIONS,
  can,
  isActivePath,
} from "../../../../views/v2/Admin/navigation";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.nav";

interface Props {
  activities: string[];
  onNavigate?: () => void;
}

export default function NavigationRail({ activities, onNavigate }: Props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const sections = ADMIN_SECTIONS.map((section) => ({
    section,
    items: ADMIN_NAVIGATION.filter(
      (item) => item.section === section && can(activities, item.activity)
    ),
  })).filter(({ items }) => items.length > 0);

  return (
    <nav aria-label={t(`${keyI18n}.label`)} className={style.rail}>
      {sections.map(({ section, items }) => {
        const headingId = `admin-nav-${section}`;

        return (
          <div aria-labelledby={headingId} className={style.section} key={section} role="group">
            <span className={`pgm-title-small ${style.sectionLabel}`} id={headingId}>
              {t(`${keyI18n}.sections.${section}`)}
            </span>

            {items.map((item) => {
              const active = isActivePath(pathname, item.path);

              return (
                <Link
                  aria-current={active ? "page" : undefined}
                  className={`pgm-label-large ${style.item} ${active ? style.itemActive : ""}`}
                  key={item.key}
                  onClick={onNavigate}
                  to={item.path}
                >
                  <span aria-hidden="true" className={`material-symbols-sharp ${style.itemIcon}`}>
                    {item.icon}
                  </span>
                  <span className={style.itemLabel}>{t(`${keyI18n}.items.${item.key}`)}</span>
                </Link>
              );
            })}
          </div>
        );
      })}
    </nav>
  );
}
